/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Filter_18_MonthsInputs */



/**
* | output |
* | --- |
* | "Last 18 months" |
*
* @param {User_Detail_Filter_18_MonthsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_filter_18_months = /** @type {((inputs?: User_Detail_Filter_18_MonthsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Filter_18_MonthsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("18 derniers mois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Últimos 18 meses")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Últimos 18 meses")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimi 18 mesi")
	return /** @type {LocalizedString} */ ("Last 18 months")
});